import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import Radios from './Radios';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import * as APIS from "../utils/service";


export default function MeettingWriter(props) {

    const {
        setmeettingwriterpop=() => {},
        customerIdx=0,
        setupdatestatus=() => {}
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const yoil = ['일', '월', '화', '수', '목', '금', '토'];
    const [searchactive, setsearchactive] = useState(0);   
    const [searchvar, setsearchvar] = useState('');   
    const [meetinglist, setmeetinglist] = useState([
        {viewernames: '3.23(화)', values: '결정력이 떨어짐. 다음 미팅을 기준으로 자동고객관리 대상 판단'},
        {viewernames: '3.15(화)', values: '자동고객관리 시작, 전송매물 열람수 확인하기'},
    ]);  

    const [row, setrow] = useState({}); 
    const [mettingsArr, setmettingsArr] = useState([]); 
    const [comment, setcomment] = useState([]); 
    const [updateIdx, setupdateIdx] = useState([]); 
    const [updateComment, setupdateComment] = useState([]); 
    
    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);
    useEffect(() => {
        rowDataSubmit();
    }, []);
    const rowDataSubmit = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = { idx: customerIdx }
        APIS.postData('/v1/customer/get', sender).then(({ data }) => {
            if(data){
                const { customer, compony_arr, my_arr, other_arr } = data;
                console.log(",,,,,", data);
                setrow(customer);
                setmettingsArr(customer?.meetings);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }

    return (
        <>
            <div className='ProductDetailArea' style={{ zIndex: 1003}}>
                <div>
                    <div className='ProductDetailAreaBG' 
                        // onClick={() => {
                        //     setmeettingwriterpop(false);
                        // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop wd500"> 
                        <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee'}}>
                            <span>미팅 기록</span>
                            <button
                                onClick={() => {
                                    setmeettingwriterpop(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />                                            
                            </button>
                        </div>
                        <div 
                            className="mettingArea padding32"
                        >
                            <div>
                                미팅기록을 입력하면 <span className='bolds'>미팅 횟수 및 최근 미팅일이 갱신</span>됩니다
                            </div>
                            <div className='tips'>
                                <div className='fontsize16 bolds'>TIP</div>
                                <div className='tipcontents margint8'>
                                    <span>1.</span>
                                    <p>미팅을 기록해두면 고객의 성향, 니즈를 파악하는데 도움됩니다.</p>
                                </div>
                                <div className='tipcontents'>
                                    <span>2.</span>
                                    <p>실제로 미팅결과를 기록하는 사람과 기록하지 않는 사람의 계약률 차이는 명확하게 납니다.</p>
                                </div>
                                <div className='tipcontents'>
                                    <span>3.</span>
                                    <p>조금 귀찮아도 기록을 생활화 하는게 어떨까요?</p>
                                </div>
                            </div>
                            <div style={{width: '100%'}}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 5}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M7.50033 1.3335V3.00016H12.5003V1.3335H14.167V3.00016H17.5003C17.9606 3.00016 18.3337 3.37326 18.3337 3.8335V17.1668C18.3337 17.6271 17.9606 18.0002 17.5003 18.0002H2.50033C2.04009 18.0002 1.66699 17.6271 1.66699 17.1668V3.8335C1.66699 3.37326 2.04009 3.00016 2.50033 3.00016H5.83366V1.3335H7.50033ZM16.667 8.8335H3.33366V16.3335H16.667V8.8335ZM12.5299 9.78016L13.7084 10.9587L9.58366 15.0835L6.63738 12.1372L7.81589 10.9587L9.58366 12.7265L12.5299 9.78016ZM5.83366 4.66683H3.33366V7.16683H16.667V4.66683H14.167V5.50016H12.5003V4.66683H7.50033V5.50016H5.83366V4.66683Z" fill="#999999"/>
                                    </svg> 
                                    <span className='bolds'>{moment().format('YYYY.MM.DD')}({yoil[moment().day()]})</span>
                                </div>
                                <div className='margint10' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8, width: '100%' }}>
                                    <div style={{ width: 'calc(100% - 88px)', height: 40}}>
                                        <textarea 
                                            placeholder='' className='inputs' style={{paddingTop: 5}}
                                            onChange={(e) => {
                                                setcomment(e.target.value);
                                            }}
                                            value={comment}
                                        ></textarea>
                                    </div>
                                    <div>
                                        <Button
                                            buttonTxt={'등록'}
                                            styles={{ 
                                                width: 80, height: 40
                                            }} 
                                            onPress={() => { 
                                                dispatch(
                                                    open({
                                                        component: '등록하시겠습니까?',
                                                        title: '알림',
                                                        button: "등록",
                                                        buttonCencle: "취소",       
                                                        titleviewer: true,                 
                                                        alert: false,
                                                        onPress: () => {
                                                            dispatch(loadingflas({ loading: true }));
                                                            let sender = { 
                                                                idx: null, 
                                                                c_idx: customerIdx,
                                                                comment: comment,
                                                                remove: false 
                                                            }
                                                            APIS.postData('/v1/customer/meetingUpdate', sender).then(({ data }) => {
                                                                if(data){
                                                                    rowDataSubmit();
                                                                    setupdatestatus(true);
                                                                    setcomment('');
                                                                    dispatch(listupdater({ listupdate: true }));
                                                                    dispatch(close());
                                                                }
                                                            }).catch(({ response }) => {
                                                                const { data } = response;
                                                            }).finally(() => {
                                                                dispatch(loadingflas({ loading: false }));
                                                            });
                                                        },
                                                        onCancelPress: () => {
                                                            dispatch(close());
                                                        }
                                                    })
                                                );                           
                                            }}
                                        />   
                                    </div>
                                </div>
                            </div>
                            <div className='meettingdatalist'>
                                {mettingsArr?.length > 0 && mettingsArr?.map((x, i) => {
                                    return (
                                        <div>
                                            <div>
                                                <span className='bolds'>{moment(x?.create_dt).format('MM.DD')}({yoil[moment(x?.create_dt).day()]})</span>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                                                    <button
                                                        onClick={() => {
                                                            setupdateIdx(x?.idx*1 === updateIdx*1 ? '' : x?.idx);
                                                            setupdateComment(x?.comment);
                                                        }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M16.6667 1.66667C17.1269 1.66667 17.5 2.03977 17.5 2.50001V5.63084L15.8333 7.2975V3.33334H4.16667V16.6667H15.8333V14.3683L17.5 12.7017V17.5C17.5 17.9603 17.1269 18.3333 16.6667 18.3333H3.33333C2.8731 18.3333 2.5 17.9603 2.5 17.5V2.50001C2.5 2.03977 2.8731 1.66667 3.33333 1.66667H16.6667ZM18.1485 7.33968L19.327 8.51817L12.8452 15L11.6649 14.9983L11.6667 13.8215L18.1485 7.33968ZM10.8333 10V11.6667H6.66667V10H10.8333ZM13.3333 6.66667V8.33334H6.66667V6.66667H13.3333Z" fill="#999999"/>
                                                        </svg>                                                   
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            dispatch(
                                                                open({
                                                                    component: '삭제하시겠습니까?',
                                                                    title: '삭제하기',
                                                                    button: "삭제",
                                                                    buttonCencle: "닫기",       
                                                                    titleviewer: true,                 
                                                                    alert: false,
                                                                    onPress: () => {
                                                                        dispatch(loadingflas({ loading: true }));
                                                                        let sender = { 
                                                                            idx: x?.idx, 
                                                                            c_idx: customerIdx,
                                                                            comment: comment,
                                                                            remove: true 
                                                                        }
                                                                        APIS.postData('/v1/customer/meetingUpdate', sender).then(({ data }) => {
                                                                            if(data){
                                                                                rowDataSubmit();
                                                                                setupdatestatus(true);
                                                                                setcomment('');
                                                                                dispatch(listupdater({ listupdate: true }));
                                                                                dispatch(close());
                                                                            }
                                                                        }).catch(({ response }) => {
                                                                            const { data } = response;
                                                                        }).finally(() => {
                                                                            dispatch(loadingflas({ loading: false }));
                                                                        });
                                                                    },
                                                                    onCancelPress: () => {
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            );  
                                                        }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <path d="M14.166 4.99984H18.3327V6.6665H16.666V17.4998C16.666 17.9601 16.2929 18.3332 15.8327 18.3332H4.16602C3.70578 18.3332 3.33268 17.9601 3.33268 17.4998V6.6665H1.66602V4.99984H5.83268V2.49984C5.83268 2.0396 6.20578 1.6665 6.66602 1.6665H13.3327C13.7929 1.6665 14.166 2.0396 14.166 2.49984V4.99984ZM14.9993 6.6665H4.99935V16.6665H14.9993V6.6665ZM7.49935 9.1665H9.16602V14.1665H7.49935V9.1665ZM10.8327 9.1665H12.4993V14.1665H10.8327V9.1665ZM7.49935 3.33317V4.99984H12.4993V3.33317H7.49935Z" fill="#999999"/>
                                                        </svg>                                                    
                                                    </button>
                                                </div>
                                            </div>
                                            <div style={{ whiteSpace: 'pre-wrap' }}>{x?.comment}</div>

                                            {x?.idx*1 === updateIdx &&
                                            <div className='margint10' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8, width: '100%' }}>
                                                <div style={{ width: 'calc(100% - 88px)', height: 40}}>
                                                    <textarea 
                                                        placeholder='' className='inputs' style={{paddingTop: 5}}
                                                        onChange={(e) => {
                                                            setupdateComment(e.target.value);
                                                        }}
                                                        value={updateComment}
                                                    ></textarea>
                                                </div>
                                                <div>
                                                    <Button
                                                        buttonTxt={'수정'}
                                                        styles={{ 
                                                            width: 80, height: 40
                                                        }} 
                                                        onPress={() => { 
                                                            dispatch(
                                                                open({
                                                                    component: '수정하시겠습니까?',
                                                                    title: '알림',
                                                                    button: "수정",
                                                                    buttonCencle: "취소",       
                                                                    titleviewer: true,                 
                                                                    alert: false,
                                                                    onPress: () => {
                                                                        dispatch(loadingflas({ loading: true }));
                                                                        let sender = { 
                                                                            idx: updateIdx, 
                                                                            c_idx: customerIdx,
                                                                            comment: updateComment,
                                                                            remove: false 
                                                                        }
                                                                        APIS.postData('/v1/customer/meetingUpdate', sender).then(({ data }) => {
                                                                            if(data){
                                                                                rowDataSubmit();
                                                                                setupdatestatus(true);
                                                                                setcomment('');
                                                                                setupdateIdx('');
                                                                                dispatch(listupdater({ listupdate: true }));
                                                                                dispatch(close());
                                                                            }
                                                                        }).catch(({ response }) => {
                                                                            const { data } = response;
                                                                            console.log(data);
                                                                        }).finally(() => {
                                                                            dispatch(loadingflas({ loading: false }));
                                                                        });
                                                                    },
                                                                    onCancelPress: () => {
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            );                           
                                                        }}
                                                    />   
                                                </div>
                                            </div>}
                                            
                                        </div>
                                    );
                                })}
                            </div>      
                            {mettingsArr?.length === 0 &&
                                <div className='nolistArea' style={{ width: '100%', height: 60}}>
                                    미팅기록이 없습니다.
                                </div>                        
                            }   
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )    
}